<a
  href="javascript:void(0)"
  (click)="showModal()"
  id="article-file-{{ id }}"
  class="kuba-document-trigger"
  [attr.aria-label]="articleName"
  [title]="articleName"
>
  <i
    class="pi pi-align-left kuba-document-icon kuba-document-icon--blue"
    aria-hidden="true"
  ></i>
</a>

<div class="article-modal" *ngIf="showModalWindow" id="article-file-{{ id }}">
  <!-- // New and Edit -->
  <div class="modal-dialog" *ngIf="editMode">
    <div class="modal-content">
      <div class="modal-header">
        <h4>
          <span class="ic-md">
            <i
              class="pi pi-align-left kuba-document-icon kuba-document-icon--blue"
              aria-hidden="true"
            ></i>
          </span>
          <span>{{ articleSrc.article.articleName }}</span>
        </h4>
        <button (click)="hideModal()" class="close">
          <span class="icon ic-md icon-multiply"></span>
        </button>
      </div>
      <div class="modal-body" id="article-pop-{{ id }}" *ngIf="articleSrc">
        <!-- Article Form -->
        <div class="modal-content-left">
          <div class="form-group">
            <label for="" translate>ARTICLE_NAME</label>
            <span class="required">*</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="articleSrc.article.articleName"
              id="articlaName"
              name="articlaName"
              [disabled]="isArticleLevelRestricted"
              #articlaName="ngModel"
              placeholder="{{ 'ARTICLE_NAME' | translate }}"
            />
            <div
              *ngIf="
                articlaName.invalid &&
                (articlaName.dirty || articlaName.touched)
              "
              class="alert alert-danger"
            >
              <div *ngIf="articlaName.errors['required']" translate>
                ARTICLE_NAME_REQ
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="" translate>DOCUMENT_NUMBER</label>
            <span class="required">*</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="articleSrc.article.documentNumber"
              id="documentNumber"
              name="documentNumber"
              placeholder="{{ 'DOCUMENT_NUMBER' | translate }}"
              [disabled]="isElectroArticle || isArticleLevelRestricted"
            />
          </div>

          <div class="form-group">
            <label for="" translate>CHAPTER</label>
            <span class="required">*</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="articleSrc.article.chapter"
              id="chapter"
              name="chapter"
              [disabled]="isArticleLevelRestricted"
              placeholder="{{ 'CHAPTER' | translate }}"
            />
          </div>

          <div class="form-group">
            <label for="" translate>VERSION</label>
            <p-inputnumber
              [showButtons]="true"
              [(ngModel)]="versionVal"
              [min]="1"
              [max]="1000"
              (onChange)="onChangeVersion(versionVal)"
            >
            </p-inputnumber>
          </div>
          <div class="form-group" *ngIf="id > 0">
            <label translate>EDITED_DATE</label>
            <p-datepicker
              name="articledate"
              inputId="articledate"
              [(ngModel)]="articleDateNative"
              (onSelect)="onDateChanged($event)"
              [showIcon]="true"
              [dateFormat]="'dd/mm/yy'"
              [minDate]="articleMinDate"
              placeholder="{{ 'CHOOSE_DATE' | translate }}"
            ></p-datepicker>
          </div>
          <div class="form-group" *ngIf="projectId === 0 && id > 0">
            <label translate>EDITED_BY</label>
            <ng-container *ngIf="rollId === 1 || rollId === 2; else editor">
              <p-select
                [options]="adminUsers"
                [(ngModel)]="selectedUser"
                optionLabel="Name"
              >
              </p-select>
            </ng-container>
            <ng-template #editor>
              <input
                type="text"
                readonly
                class="form-control"
                [(ngModel)]="editorEditedBY"
                id="editedBy"
                name="editedBy"
              />
            </ng-template>
          </div>

          <form class="form" enctype="multipart/form-data">
            <ng-container *ngIf="showStatus">
              <div
                class="checkbox"
                *ngFor="let sArticle of articleSrc.subArticles"
              >
                <label *ngIf="showArticleText(sArticle)">
                  <ng-container
                    *ngIf="sArticle.name !== 'Own Text' || businessId"
                  >
                    <input
                      type="checkbox"
                      (change)="updateStatus($event, sArticle)"
                      [disabled]="sArticle.disable"
                      name="{{ sArticle.name }}"
                      [ngModel]="checkStatus(sArticle.status)"
                    />
                    {{ sArticle.name | translate }}
                  </ng-container>
                </label>
              </div>
            </ng-container>
          </form>
        </div>
        <!-- Article (Sub Articles) -->
        <div class="modal-content-right">
          <div class="row">
            <div class="col-sm-8">
              <!-- tabs -->
              <tabset type="pills">
                <ng-container *ngFor="let tabz of articleSrc.subArticles">
                  <tab
                    *ngIf="isVisible(tabz)"
                    (selectTab)="tabSelection(tabz)"
                    [heading]="tabz.name | translate"
                  >
                    <ckeditor
                      [editor]="Editor"
                      [config]="config"
                      [(ngModel)]="tabz.text"
                      [disabled]="isReadonly(tabz)"
                    ></ckeditor>
                  </tab>
                </ng-container>

                <tab
                  heading="{{ 'PREVIEW' | translate }}"
                  (selectTab)="previewTabSelection()"
                  (deselect)="previewActive = false"
                  [active]="previewActive"
                >
                  <div class="preview-pane">
                    <ckeditor
                      [editor]="InlineEditor"
                      [config]="previewEditorConfig"
                      [data]="createPreviewTextContent(articleSrc.subArticles)"
                      [disabled]="true"
                    >
                    </ckeditor>
                  </div>
                </tab>
              </tabset>
            </div>
            <div class="col-sm-4" *ngIf="showMergeField">
              <h4 translate>MERGE_FIELD_LIST</h4>
              <div
                class="default-list"
                style="max-height: 200px; overflow: auto"
              >
                <div *ngFor="let item of mergeFieldItems">
                  <div class="list-item">
                    <a
                      href="javascript:void(0);"
                      (click)="clickMergeField($event)"
                    >
                      {{ language === "en" ? item.engText : item.norText }}
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="
                  isProject && workingModuleId != 18 && workingModuleId != 41
                "
              >
                <label for="lblApprovalPersons" class="control-label">
                  <span translate>PROJECT</span>
                </label>
                <div>
                  <p-multiSelect
                    [options]="ProjectOptions"
                    [style]="{ width: '100%', height: '30px' }"
                    [(ngModel)]="ProjectData"
                    (onChange)="onChangeProjectDropDown()"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div
                class="form-group"
                *ngIf="isFdv && workingModuleId != 16 && workingModuleId != 41"
              >
                <label for="lblApprovalPersons" class="control-label">
                  <span translate>FDV</span>
                </label>
                <div>
                  <p-multiSelect
                    [options]="FdvOptions"
                    [style]="{ width: '100%', height: '30px', display: 'flex' }"
                    [(ngModel)]="FdvData"
                    (onChange)="onChangeFdvDropDown()"
                  >
                  </p-multiSelect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          [disabled]="
            !articleSrc.article.articleName ||
            !articleSrc.article.documentNumber ||
            !articleSrc.article.chapter
          "
          type="button"
          *ngIf="showSave"
          class="btn btn-primary"
          (click)="saveArticle()"
        >
          <span translate>SAVE_CHANGES</span>
        </button>
      </div>
    </div>
  </div>

  <!-- // View Mode -->
  <div class="modal-dialog" *ngIf="!editMode && articleSrc.id != 0">
    <div class="modal-content">
      <div class="modal-header">
        <h4>
          <span class="ic-md">
            <i
              class="pi pi-align-left kuba-document-icon kuba-document-icon--blue"
              aria-hidden="true"
            ></i>
          </span>
          <span>{{ articleSrc.article.articleName }}</span>
        </h4>
        <button
          (click)="hideModal()"
          class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row close"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="modal-body" id="article-pop-{{ id }}" *ngIf="articleSrc">
        <div class="container">
          <div class="row">
            <div class="col-sm-8 offset-sm-2">
              <div class="article-print-preview">
                <div class="mb-3">
                  <button
                    class="btn text-primary btn-icon"
                    (click)="exportArticlePdf()"
                  >
                    <i class="pi pi-print"></i>
                    <span translate>PRINT_AS_PDF</span>
                  </button>
                </div>
                <div class="article-pp-info">
                  <h2>{{ articleSrc.article.articleName }}</h2>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <label translate>CHAPTER</label>:
                          <label class="text-primary">{{
                            articleSrc.article.chapter
                          }}</label>
                        </div>
                        <div class="col-md-3">
                          <label translate>DOCUMENT_NUMBER</label>:
                          <label class="text-primary"
                            >{{ articleSrc.article.documentNumber }}
                          </label>
                        </div>
                        <div class="col-md-3">
                          <label translate>RELEASE_DATE</label>:
                          <label class="text-primary">{{ createdDate }}</label>
                        </div>
                      </div>
                      <div *ngFor="let headerData of displayHeaderDetails()">
                        <div class="row">
                          <div class="col-md-6">
                            <label translate>{{ headerData.name }}&nbsp;</label>

                            <label translate>VERSION_LOW_CASE</label>:
                            <label
                              *ngIf="headerData.version > 10"
                              class="text-primary"
                              >{{ headerData.version }}</label
                            >
                            <label
                              *ngIf="headerData.version < 10"
                              class="text-primary"
                              ><span>0</span>{{ headerData.version }}</label
                            >
                          </div>
                          <div class="col-md-3">
                            <label translate>EDITED_BY</label> :
                            <label class="text-primary">{{
                              headerData.editedBy
                            }}</label>
                          </div>
                          <div class="col-md-3">
                            <label translate>EDITED_DATE</label> :
                            <label class="text-primary">
                              {{ headerData.editedDate }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="article-pp-content card">
                  <ckeditor
                    class="article-pp-subarticle card-body"
                    [editor]="InlineEditor"
                    [config]="previewEditorConfig"
                    [data]="
                      createPreviewTextContent(
                        displaySubArticle && displaySubArticle.length > 0
                          ? displaySubArticle
                          : articleSrc.subArticles
                      )
                    "
                    [disabled]="true"
                  >
                  </ckeditor>
                </div>
                <hr />
                <div class="article-signature">
                  <div class="row">
                    <div class="col-sm-6">
                      <label translate>DATE</label>: {{ displayDate }}
                    </div>
                    <div class="col-sm-6 text-right">
                      <img
                        *ngIf="
                          articleSrc.article && articleSrc.article.signaturePath
                        "
                        [src]="articleSrc.article.signaturePath"
                        width="100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <footer class="article-pp-footer"></footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>
